/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../types';

import * as TypescriptOperationsGenerated from "graphql/typescript-operations.generated"
import * as Operations from 'graphql/document-nodes.generated';
import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router'
import { QueryHookOptions, useQuery } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient , ApolloClientContext} from 'withApollo';
export async function getServerPageGetSectionById
    (options: Omit<Apollo.QueryOptions<TypescriptOperationsGenerated.GetSectionByIdQueryQueryVariables>, 'query'>, ctx: ApolloClientContext ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<TypescriptOperationsGenerated.GetSectionByIdQueryQuery>({ ...options, query: Operations.GetSectionByIdQueryDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export const useGetSectionById = (
  optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetSectionByIdQueryQuery, TypescriptOperationsGenerated.GetSectionByIdQueryQueryVariables>) => {
  const router = useRouter();
  const options = optionsFunc ? optionsFunc(router) : {};
  return useQuery(Operations.GetSectionByIdQueryDocument, options);
};
export type PageGetSectionByIdComp = React.FC<{data?: TypescriptOperationsGenerated.GetSectionByIdQueryQuery, error?: Apollo.ApolloError}>;
export const withPageGetSectionById = (optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetSectionByIdQueryQuery, TypescriptOperationsGenerated.GetSectionByIdQueryQueryVariables>) => (WrappedComponent:PageGetSectionByIdComp) : NextPage  => (props) => {
                const router = useRouter()
                const options = optionsFunc ? optionsFunc(router) : {};
                const {data, error } = useQuery(Operations.GetSectionByIdQueryDocument, options)    
                return <WrappedComponent {...props} data={data} error={error} /> ;
                   
            }; 
export const ssrGetSectionById = {
      getServerPage: getServerPageGetSectionById,
      withPage: withPageGetSectionById,
      usePage: useGetSectionById,
    }